<template>
  <div id="sig-container" class="block full form-horizontal">
    <div class="loader" v-if="loading">
      <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
    </div>
    <div class="widget">
      <div
        class="
          widget-content widget-content-mini
          themed-background-dark-default
          text-light
        "
      >
        <span class="float-right text-muted">
          <button
            type="button"
            @click="$router.go(-1)"
            class="btn btn-xs btn-primary"
          >
            Volver
          </button>
        </span>
        Informe asignación de abonos
      </div>
      <div
        class="widget-content border-bottom themed-background-muted text-center"
      >
        <div class="container">
          <div class="form-group text-center">
            <label
              class="control-label col-lg-3 col-md-2"
              v-text="'Fecha abono'"
            ></label>
            <div class="col-lg-12 col-md-12">
              <date-picker
                id="datepicker"
                v-model="params.fecha_inicio"
                :placeholder="'Fecha inicio'"
                :bootstrap-styling="true"
                :clear-button="true"
                format="yyyy-MM-dd"
                :language="es"
              ></date-picker>
              <p id="space">
                <date-picker
                  id="datepicker"
                  v-model="params.fecha_fin"
                  :placeholder="'Fecha fin'"
                  :bootstrap-styling="true"
                  :clear-button="true"
                  format="yyyy-MM-dd"
                  :language="es"
                ></date-picker>
              </p>
            </div>
          </div>
          <div class="form-group">
            <label
              class="control-label col-lg-3 col-md-2"
              v-text="'Asesor'"
            ></label>
            <div class="col-lg-12 col-md-12">
              <select
                class="form-control"
                id="datos_usuarios"
                v-model="params.usuario_id"
              >
                <option :value="null">Seleccione el Asesor</option>
                <option
                  v-for="usuario in usuarios"
                  :key="usuario.id"
                  :value="usuario.id"
                >
                  {{
                    usuario.nombres
                      ? usuario.nombres
                      : null + usuario.apellidos
                      ? usuario.apellidos
                      : null
                  }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label
              class="control-label col-lg-3 col-md-2"
              v-text="'Casa cobranza'"
            ></label>
            <div class="col-lg-12 col-md-12">
              <select
                class="form-control"
                id="casa"
                v-model="params.casa_cobranza"
              >
                <option :value="null">Seleccione la casa de cobranza</option>
                <option v-for="casa in casas" :key="casa.nit" :value="casa.nit">
                  {{ casa.nombre ? casa.nombre : null }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-actions">
            <button class="btn btn-primary" @click="index()">Aplicar</button
            >&nbsp;
            <button class="btn btn-primary" @click="descargarConsulta()">
              Descargar excel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <table-component :data="datos">
        <table-column
          slot="label"
          :label="'Id'"
          v-bind:value="'obligacion_id'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor'"
          v-bind:value="'valor'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha abono'"
          v-bind:value="'fecha'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha contabilizacion'"
          v-bind:value="'fecha_contabilizacion'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Nombre usuario'"
          v-bind:value="'username'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Nombre asesor'"
          v-bind:value="'nombres'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Identificación'"
          v-bind:value="'identificacion'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Id acuerdo'"
          v-bind:value="'id_acuerdo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha primer pago'"
          v-bind:value="'fecha_primer_pago'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Dia pago'"
          v-bind:value="'dia_pago'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Monto a congelar'"
          v-bind:value="'monto_congelar'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Cuotas'"
          v-bind:value="'cuotas'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor cuota'"
          v-bind:value="'valor_cuota'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor cuota inicial'"
          v-bind:value="'valor_cuota_inicial'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Valor compromiso'"
          v-bind:value="'valor_compromiso'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Tipo'"
          v-bind:value="'tipo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Nit casa cobranza'"
          v-bind:value="'casa_cobranza_nit'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Casa cobranza'"
          v-bind:value="'casa_cobranza_nombre'"
        ></table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "AsignacionAbono",
  data: () => {
    return {
      params: {
        usuario_id: null,
        fecha_inicio: null,
        fecha_fin: null,
        casas: null,
      },
      datos: [],
      es: es,
      errors: null,
    };
  },
  components: {
    TableComponent: () => import("@@/components/table/TableComponent"),
    TableColumn: () => import("@@/components/table/TableColumn"),
    "date-picker": Datepicker,
  },
  computed: {
    ...mapGetters({ loading: "loading" }),
    usuarios() {
      return this.$store.getters["user/usuarios"];
    },
    casas() {
      return this.$store.getters["casascobranza/casas"];
    },
  },
  methods: {
    index() {
      this.$store
        .dispatch("index", {
          endpoint: "informes/asignacion-abono",
          params: this.params,
        })
        .then((response) => {
          this.show = this.datos = response;
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });
    },
    async descargarConsulta() {
      await this.$store
        .dispatch("index", {
          endpoint: "informes/asignacion-abono",
          params: this.params,
        })
        .then((response) => {
          this.datos = response;
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Advertencia!",
            type: "danger",
            content: "Se ha presentado un error realizando su consulta",
          });
        });

      let data = this.datos;
      //
      data.forEach((element) => {
        delete element.apellidos;
        delete element.usuario_id;
        delete element.fecha_abono;
        delete element.valor_abono;
      });
      data = XLSX.utils.json_to_sheet(data, {
        header: [
          "obligacion_id",
          "valor",
          "fecha",
          "fecha_contabilizacion",
          "origen_abono",
          "codigo",
          "id_garantia",
          "username",
          "nombres",
          "identificacion",
          "id_acuerdo",
          "fecha_primer_pago",
          "dia_pago",
          "monto_congelar",
          "cuotas",
          "valor_cuota",
          "valor_cuota_inicial",
          "valor_compromiso",
          "tipo",
          "casa_cobranza_nit",
          "casa_cobranza_nombre",
          "eliminado"
        ],
      });

      data["A1"].v = "Id";
      data["B1"].v = "Valor";
      data["C1"].v = "Fecha abono";
      data["D1"].v = "Fecha contabilizacion";
      data["E1"].v = "Origen abono";
      data["F1"].v = "Código";
      data["G1"].v = "Id garantía";
      data["H1"].v = "Nombre usuario";
      data["I1"].v = "Nombre asesor";
      data["J1"].v = "Identificación";
      data["K1"].v = "Id acuerdo";
      data["L1"].v = "Fecha primer pago";
      data["M1"].v = "Dia pago";
      data["N1"].v = "Monto a congelar";
      data["O1"].v = "Cuotas";
      data["P1"].v = "Valor cuota";
      data["Q1"].v = "Valor cuota inicial";
      data["R1"].v = "Valor compromiso";
      data["S1"].v = "Tipo";
      data["T1"].v = "Nit casa cobranza";
      data["U1"].v = "Casa cobranza";
      data["V1"].v = "Eliminado";

      var workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, data, "Asignación Abonos");
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
      var wbout = XLSX.write(workbook, wopts);
      saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "Asignación Abonos.xlsx"
      );
    },
  },
  mounted() {
    //
    this.$store.dispatch("user/fetchUsuarios", {
      endpoint: "usuario",
      params: { paginar: false, casa_cobranza: 1, asesores: "true" },
    });
    this.$store.dispatch("casascobranza/fetch", {
      endpoint: "administracion/casascobranza",
      params: {
        paginar: "false",
      },
    });
  },
};
</script>
<style>
#space {
  padding-top: 10px;
}
#datepicker {
  background: white;
  padding-top: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.disponibles {
  display: flow-root !important;
}
.titulos-disponible {
  padding-left: initial !important;
  padding-right: initial !important;
}
.table thead > tr > th {
  font-size: 14px !important;
}

.table thead > tr > td {
  font-size: 10px !important;
}

.table-responsive {
  overflow: auto !important;
  width: 100%;
}
</style>